import React from "react";
import logo from "../../assets/logo.svg";
import { Link } from "react-router-dom";

const Footer = () => {
  const Year = new Date().getFullYear();

  return (
    <section className="sm:bg-hero-lg bg-cover  w-full text-white max-sm:px-5 max-sm:bg-black">
      <div className="flex max-w-7xl m-auto py-10 justify-between flex-wrap max-sm:flex-col gap-10 ">
        <img width="212px" className="max-sm:w-28" src={logo} alt="logo" />
        {/* <div className="flex gap-12"> */}
        <div className="mt-6">
          <h3 className="font-semibold text-2xl mb-5">Quick Links</h3>
          <ul className="space-y-4">
            <li>
              <a href="/">Home</a>{" "}
            </li>
            <li>
              <a href="#courses">Courses</a>{" "}
            </li>
            <li>
              <a href="#about">About Us</a>{" "}
            </li>
            <li>
              <a href="#contact">Contact Us</a>{" "}
            </li>
          </ul>
        </div>
        <div className="mt-6">
          <h3 className="font-semibold text-2xl mb-5">Contact Us</h3>
          <ul className="space-y-4">
            <li>21C, Diversion Road, Polur 606803, Tiruvannamalai district</li>
            <li>+91 9361319990</li>
            <li>Academicainsightirs@gmail.com</li>
          </ul>
        </div>
        {/* </div> */}
        <div>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3895.1236282726936!2d79.1267464!3d12.507963799999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bacd941fac683b9%3A0x251cdab13c405488!2sAcademia%20Insight%20Institute%20Of%20Research%20Studies!5e0!3m2!1sen!2sin!4v1747839585285!5m2!1sen!2sin"
            width="300"
            height="300"
            allowfullscreen="map"
            title="map"
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </div>
      <hr className="border border-white" />
      <div className="flex max-w-7xl m-auto py-4 justify-between max-sm:flex-col max-sm:gap-4  max-sm:items-center">
        <p>
          &copy;{Year} Academia Insight Institute of Research Studies. All
          Rights Reserved
        </p>
        <a href="/privacy" className="text-sm text-gray-300 underline">
          Privacy and Policy
        </a>
        <p>
          Powered By <a href="#">PROGG</a>
        </p>
      </div>
    </section>
  );
};

export default Footer;
